import React from "react";
import { useAuth } from "@/lib/auth";
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Building2, Check, ChevronDown } from "lucide-react";

export default function CompanySwitcher() {
    const { companies, activeCompanyId, switchCompany } = useAuth();
    const active = companies.find((c) => c.id === activeCompanyId);
    if (!companies?.length) return null;
    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                className="flex items-center gap-2 h-9 px-3 rounded-md border border-border bg-background hover:bg-secondary text-sm font-medium"
                data-testid="company-switcher"
            >
                <Building2 className="size-4 text-muted-foreground" />
                <span className="truncate max-w-[180px]">{active?.name || "Select company"}</span>
                <ChevronDown className="size-4 text-muted-foreground" />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="w-72">
                <DropdownMenuLabel>Switch Company</DropdownMenuLabel>
                <DropdownMenuSeparator />
                {companies.map((c) => (
                    <DropdownMenuItem
                        key={c.id}
                        onClick={() => { switchCompany(c.id); window.location.reload(); }}
                        data-testid={`company-option-${c.code}`}
                    >
                        <div className="flex items-center justify-between w-full">
                            <div>
                                <div className="font-medium">{c.name}</div>
                                <div className="text-xs text-muted-foreground">{c.code}</div>
                            </div>
                            {c.id === activeCompanyId && <Check className="size-4 text-primary" />}
                        </div>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
